import * as _ from 'lodash';
import { StepAction } from './stepAction';
import { getLogger } from '../../commons/logger';
import type { IncomingParams } from 'clickim/src/background/playbackContext';
import type { EvaluateExpressionStep } from 'clickim/src/common/models/evaluateExpressionStep';

const logger = getLogger('evaluate-expression-step-action');

export class EvaluateExpressionStepAction extends StepAction<EvaluateExpressionStep> {
    override async execute() {
        const { step, context, exportsGlobal, exportsTest } = this;

        try {
            logger.info('runner running incoming params evaluation');
            let incomingParams = context.incomingParams || {} as IncomingParams;
            if (_.isEmpty(incomingParams)) {
                incomingParams = this.sessionPlayerInit.StepParamsBuilder.getStepInputs(step as any as EvaluateExpressionStep, context, exportsGlobal, exportsTest);
            }

            const params = ['context', ...incomingParams.as.functionParameters];
            const args = [context, ...incomingParams.as.functionArguments];
            const expressionToEvaluate = step.subType === 'text' ? `'${step.expression!.replace(/'/g, "\\'")}'` : step.expression;
            const code = `return ${expressionToEvaluate}`.replace(/\n/g, '\\n');
            const textEvaluateFunction = Function.apply(Function, params.concat([code]));
            const evaluatedText = textEvaluateFunction(...args);

            context.data[step.targetName!] = evaluatedText;
            context.data[step.targetId!] = evaluatedText;
            if (context.internalParams) {
                context.internalParams.add(step.targetId!);
            }

            const result = {
                success: true,
                evaluatedText,
                data: context.data,
            };

            return result;
        } catch (e) {
            const { stepResult } = this.sessionPlayerInit.commonConstants;
            // TODO: Fix throwing non-error
            // eslint-disable-next-line @typescript-eslint/only-throw-error
            throw { errorType: stepResult.EVALUATE_EXPRESSION_EXCEPTION, resultInfo: { exception: e.toString() }, success: false };
        }
    }
}
